export const DICH_VU = "dich_vu"
const ROUTER = {
  DEFAULT: "/",
  SVG_VIEWER: "/svg-viewer",
  HOME: "/",
  DANG_KY: "/dang-ky",

  //ANONYMOUS
  LICH_HOP_CUA_TOI: "/lich-hop-cua-toi",
  DANG_KY_LICH_HOP: "/dang-ky-lich-hop",
  DANG_KY_THONG_TIN_KHACH: "/dang-ky-thong-tin-khach",
  TRA_CUU_DON: "/tra-cuu-don",
  // ADMIN
  QUAN_LY_LICH_HOP: "/quan-ly-lich-hop",
  QUAN_LY_PHONG_HOP: "/quan-ly-phong-hop",
  QUAN_LY_PHAN_QUYEN: "/phan-quyen",
  DANH_BA_NHAN_VIEN: "/danh-ba-nhan-vien",
  DANH_SACH_CONG_VAN: "/danh-sach-cong-van",
  IMPORT_CONG_VAN: "/import-cong-van",
  DANH_SACH_CHUC_VU: "/danh-sach-chuc-vu",
  //User
  DICH_VU: DICH_VU,
  THONG_TIN_TAI_KHOAN: `/${DICH_VU}/thong-tin-ca-nhan`,
  DOI_MAT_KHAU: `/${DICH_VU}/doi-mat-khau`,
}
export default ROUTER
